import React from 'react'
import { Outlet } from 'react-router-dom'

function DischargeSummary() {
  return (
    <div><Outlet /></div>
  )
}

export default DischargeSummary